import React from 'react';
import PropTypes from 'prop-types';
import staticWidgets from '../../../../website/widgets/static';
import dynamicWidgets from '../../../../website/widgets/dynamic/server';
import Placeholder from '../../../../website/widgets/static/Placeholder';

const WidgetLoader = ({
  id,
  type,
  payload = {},
  componentId,
  ...props
}) => {
  if (!componentId) {
    return false;
  }

  const Widget = dynamicWidgets[componentId] || staticWidgets[componentId];
  // This case happens when a Widget has been completely deleted from Voyager
  // or someone forgot to add it to the exports from static/dynamic widgets
  if (!Widget) {
    return (
      <Placeholder>
        The widget {type} is no longer available.
      </Placeholder>
    );
  }

  return (
    <>
      <Widget
        isEditable={false}
        isEditing={false}
        id={id}
        {...(Widget.manifestInfo.defaultPayload || {})}
        {...payload}
        payload={payload}
        componentId={Widget.manifestInfo.componentId}
        {...props}
      />
    </>
  );
};

WidgetLoader.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  payload: PropTypes.object,
  componentId: PropTypes.string.isRequired,
};

export default WidgetLoader;
